import { Grid } from '@material-ui/core';
import { VEHICLE_STATUSES } from '../../../../../../../constants';
import { useViewedVehicle } from '../../../../hooks/useViewedVehicle';
import { PullVehicleBlock } from './PullBlock';
import { RelistVehicleBlock } from './RelistBlock';
import { DeactivateBlock } from './DeactivateBlock';
import { ActionDivider } from '../../../UI';

export const PullVehicleControls = () => {
  const currentVehicle = useViewedVehicle();

  if (!currentVehicle || currentVehicle.status === VEHICLE_STATUSES.DRAFT) return null;

  if (currentVehicle.status !== VEHICLE_STATUSES.PULLED) {
    return (
      <Grid item xs={12}>
        <PullVehicleBlock />
        <ActionDivider />
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <RelistVehicleBlock />
      <ActionDivider />
      <DeactivateBlock />
      <ActionDivider />
    </Grid>
  );
};
